import React from 'react';
import { IconButton, IconButtonProps } from '@material-ui/core';
import { useStyles } from './CloseIcon.styles';
import Close from '@material-ui/icons/Close';
import TooltipOne from '../../TooltipOne/TooltipOne.component';

export const CloseIcon: React.FC<IconButtonProps> = (props) => {
  const classes = useStyles();
  return (
    <TooltipOne title={'Zamknij'} placement="top">
      <IconButton disableRipple className={classes.icon} {...props} size={'small'}>
        <Close />
      </IconButton>
    </TooltipOne>
  );
};
